/* eslint-disable no-loop-func */

import React, { Component } from 'react';
import { Button } from 'reactstrap';
import HeaderComponent from "../../../components/header/HeaderComponent";
import ErrorComponent from '../../../components/error/ErrorComponent'
import LoadingComponent from '../../../components/loading/LoadingComponent'
import AttendanceViewTableRow from "./AttendanceViewTableRow";
import AttendanceViewTableHeader from "./AttendanceViewTableHeader";
import { LuChevronRight, LuChevronLeft, LuRefreshCw  } from "react-icons/lu";
import { BiSearch } from "react-icons/bi";
import InputTextComponent from "../../../components/forms/InputTextComponent";

const stringUtil = require('../../../utils/string/stringUtil');
const dateUtil = require('../../../utils/dateUtil/dateUtil');
const staffUtility = require('../../../utils/domain/staff/staffUtility');
const rmsApiProxyRetry = require('../../../utils/api/rmsApiProxyRetry');
const logger = require('../../../utils/logger/logger');
const stateManager = require('../../../utils/state/stateManager');
const translator = require('../../../utils/translator/translator');
const constants = require('../../../utils/domain/constants');
const commonUtility = require('../../../utils/domain/commonUtility');

const screenKeyboardAction = require('../../../utils/state/actions/views/onScreenKeyboard/screenKeyboardAction');
const navigationPageAction = require('../../../utils/state/actions/views/navigationPage/navigationPageAction');

const arraySort = require('array-sort');

const noOfDaysInPastForAttendance = 30;
const noOfDaysToDisplayForAttendance = 7;

class AttendanceView extends Component 
{

    constructor(props)
    {
        super(props);

        this.renderError = this.renderError.bind(this);
        this.renderSearchingBody = this.renderSearchingBody.bind(this);
        this.getAttendanceStaffs = this.getAttendanceStaffs.bind(this);
        this.getAttendanceDates = this.getAttendanceDates.bind(this);

        this.onRefreshButton = this.onRefreshButton.bind(this);

        this.state = {};
        this.state.stage = 'searching';
        this.state.error = null;

        this.state.unmounted = false;

        this.state.searchText = "";
        this.state.index = 0;

        this.state.attendanceStaffs = [];
        this.state.attendanceDates = [];
    }

    render()
    {
        return  <div className='h-100'>
                    {this.renderToolbar()}
                    {
                        (!stringUtil.isStringNullOrEmpty(this.state.error)) ?
                            this.renderError() :

                            (this.state.stage === 'searching') ?
                                this.renderSearchingBody() :

                                (this.state.stage === 'loaded') ?
                                    <div style={{height:'90vh', overflowY:'auto'}}>
                                        <RenderAttendanceBody searchText={this.state.searchText} attendanceStaffs={this.state.attendanceStaffs} attendances={this.state.attendances} endDate={this.state.endDate} fromDate={this.state.fromDate} attendanceDates={this.state.attendanceDates} index={this.state.index} /> 
                                    </div> : 
                                        null
                    }

                </div>;
    }

    renderToolbar()
    {
        let isDisabled = stringUtil.areStringSame(this.state.stage, 'searching') 
                            || this.state.error != null 
                            
        let isSearchDisabled = isDisabled
                                || !this.state.attendanceStaffs 
                                || this.state.attendanceStaffs.length <= 1;

        return  <HeaderComponent title={this.props.title}>
                    <table style={{width:'100%'}}>
                        <tr>
                            <td style={{width:'80%', whiteSpace:'nowrap'}}>
                                <div style={{marginRight:'10px'}}>
                                    <InputTextComponent     
                                        disabled={isSearchDisabled} 
                                        placeholder={
                                            <span> 
                                                <BiSearch /> {translator.getLabel("search")}
                                            </span>
                                        } 
                                        value={this.state.searchText}
                                        inputTextType="text"
                                        onValueChange={(value)=>
                                            {
                                                this.state.searchText = value;
                                                this.setState({});
                                            }}/>
                                </div>
                            </td>

                            <td>
                                <div style={{marginRight:'70px'}}>
                                    <Button 
                                        className='btn-action' 
                                        disabled={isDisabled} 
                                        style={{minWidth:'5vw', height: 'calc(3.5rem + calc(var(--bs-border-width) * 2))', minHeight: 'calc(3.5rem + calc(var(--bs-border-width) * 2))'}}
                                        onClick={() => 
                                            {
                                                logger.usage("Attendance.Refresh", "Staff clicked refresh button to refresh attendance");
                                                this.onRefreshButton();
                                            }}>
                                        <LuRefreshCw/>
                                    </Button>
                                </div>
                            </td>

                            <td>
                                <div style={{marginRight:'5px'}}>
                                    <Button 
                                        className="btn-action" 
                                        disabled={isDisabled || this.state.index === 0} 
                                        style={{minWidth:'5vw', height: 'calc(3.5rem + calc(var(--bs-border-width) * 2))', minHeight: 'calc(3.5rem + calc(var(--bs-border-width) * 2))'}}
                                        onClick={()=>
                                        {
                                            logger.usage("Attendance.Previous", "Staff clicked previous button to view attendance for previous dates");
                                            this.state.index = this.state.index - 1;
                                            this.setState({});
                                        }}>
                                        <LuChevronLeft style={{fontSize: '2.5rem'}}/>
                                    </Button>
                                </div>
                            </td>
                            <td>
                                <div style={{marginRight:'70px'}}>
                                    <Button 
                                        className="btn-action" 
                                        disabled={isDisabled || this.state.attendanceDates.length < noOfDaysToDisplayForAttendance || this.state.index + noOfDaysToDisplayForAttendance === this.state.attendanceDates.length} 
                                        style={{minWidth:'5vw', height: 'calc(3.5rem + calc(var(--bs-border-width) * 2))', minHeight: 'calc(3.5rem + calc(var(--bs-border-width) * 2))'}}
                                        onClick={()=>
                                        {
                                            logger.usage("Attendance.Next", "Staff clicked next button to view attendance for next dates");                                                
                                            this.state.index = this.state.index + 1;
                                            this.setState({});
                                        }} >
                                        <LuChevronRight style={{fontSize: '2.5rem'}}/>
                                    </Button>
                                </div>
                            </td>

                            <td style={{whiteSpace:'nowrap'}}>
                                <Button 
                                    className='btn-cancel'
                                    style={{height: 'calc(3.5rem + calc(var(--bs-border-width) * 2))', minHeight: 'calc(3.5rem + calc(var(--bs-border-width) * 2))'}}
                                    onClick={()=>
                                        {
                                            logger.usage("SalesView.Exit", "Staff clicked exit button to exit");
                                            this.state.unmounted = true;
                                            stateManager.getStore().dispatch(screenKeyboardAction.createAction(null));
                                            stateManager.getStore().dispatch(navigationPageAction.createAction(null))
                                        }}>{translator.getLabel("exit")}
                                </Button>
                            </td>

                            
                        </tr>
                    </table>
                </HeaderComponent>
    }

    renderError()
    {
        return  <div className='h-50 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                    <ErrorComponent error={this.state.error}/>
                </div>
    }

    renderSearchingBody()
    {
        this.state.error = null;
        this.state.attendances = null;

        this.state.endDate = dateUtil.getToday();
        this.state.fromDate = dateUtil.subtractDays(this.state.endDate, noOfDaysInPastForAttendance);

        var attendanceResourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/hr/attendance?start=${this.state.fromDate}&end=${this.state.endDate}`;
        rmsApiProxyRetry.get(attendanceResourceUrl)
            .then(results =>
            {
                if (results == null)
                    results = [];

                this.state.attendances = this.filterRawAttendance(results);
                this.state.attendanceStaffs = this.getAttendanceStaffs();
                this.state.attendanceDates = this.getAttendanceDates();

                if(this.state.unmounted) return;

                this.state.stage = 'loaded';
                this.setState({});
            }, error =>
            {
                logger.error(`Error occurred while loading attendance. ${error}`, {}, error);

                if(this.state.unmounted) return;

                this.state.error = error;
                this.setState({});
            });

        return this.showLoader();
    }

    showLoader()
    {
        return  <div className='h-50 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                    <LoadingComponent waitMessage={translator.getLabel("please_wait_loading_attendance")}/>
                </div>
    }

    filterRawAttendance(rawAttendances)
    {
        var filteredAttendances = [];

        rawAttendances.forEach(rawAttendance =>
        {
            if (rawAttendance.isVoided)
                return;

            if (commonUtility.getPropertyOperatingConfiguration().attendanceAccess === constants.attendanceAccess.published && rawAttendance.isDraft)
                return;

            filteredAttendances.push(rawAttendance);
        });

        return filteredAttendances;
    }

    getAttendanceStaffs()
    {
        var attendanceStaffs = [];

        if (this.state.attendances == null || this.state.attendances.length <= 0) return [];

        this.state.attendances.forEach(attendance =>
        {
            if (attendanceStaffs.some(rs => rs.staffId === attendance.staffId))
                return;

            var staff = staffUtility.getAllStaff().find(s => s.id === attendance.staffId);
            if (staff == null)
                return;

            var attendanceStaff = {};
            attendanceStaff.staffId = attendance.staffId;
            attendanceStaff.name = staffUtility.getStaffCompleteName(staff);
            attendanceStaff.pictUrl = staff.pictUrl;
            attendanceStaffs.push(attendanceStaff);
        });

        return arraySort(attendanceStaffs, "name");
    }

    getAttendanceDates()
    {
        let endDate = this.state.endDate;
        let fromDate = this.state.fromDate;
        let attendances = this.state.attendances;

        var attendanceDates = [];

        var attendanceFoundForDate = endDate;

        while (attendanceFoundForDate >= fromDate)
        {
            var allAttendancesForDate = [];

            attendances.forEach(attendance =>
            {
                if (!dateUtil.isDateComponentSame(attendance.start, attendanceFoundForDate))
                    return;

                    allAttendancesForDate.push(attendance);
            });

            if (allAttendancesForDate.length > 0)
            {
                attendanceDates.push(attendanceFoundForDate);
            }

            attendanceFoundForDate = dateUtil.subtractDays(attendanceFoundForDate, 1);
        }

        return attendanceDates;
    }

    getAllAttendancesForDate(date)
    {
        var dateAttendances = [];
        this.state.attendances.forEach(attendance =>
        {
            if (!dateUtil.isDateComponentSame(attendance.start, date))
                return;

            dateAttendances.push(attendance);
        });
        return dateAttendances;
    }

    onRefreshButton()
    {
        this.state.stage = 'searching';
        this.setState({});
    }
}

export default AttendanceView;

const RenderAttendanceBody = ({attendanceStaffs, searchText, endDate, fromDate, attendances, attendanceDates, index}) =>
{
    if (!stringUtil.isStringNullOrEmpty(searchText))
    {
        searchText = stringUtil.trimString(searchText);
        attendanceStaffs = attendanceStaffs.filter(staff => staff.name.toLowerCase().includes(searchText.toLowerCase()))
    }

    if (attendanceStaffs == null || attendanceStaffs.length <= 0)
    {
        return  <div className='h-50 caption primary-color d-flex flex-column justify-content-center align-items-center'>
                    <ErrorComponent error={"No attendance found!"}/>
                </div>
    }
    
    attendanceDates.sort((a, b) => dateUtil.isAfter(b, a));
    attendanceDates = arraySort(attendanceDates, {reverse: true})
    let attendanceDatesForPeriod = attendanceDates.slice(index, index + noOfDaysToDisplayForAttendance);

    return <div style={{ position: 'relative', overflow: 'auto', whiteSpace: 'nowrap' }}>
        <table class="pure-table pure-table-bordered" width='100%'>
            <thead style={{ background: '#FFFFFF' }}>
                <AttendanceViewTableHeader endDate={endDate} fromDate={fromDate} attendanceDates={attendanceDatesForPeriod} />
            </thead>
            <tbody>
                {
                    attendanceStaffs.map((attendanceStaff) => 
                    (
                        <AttendanceViewTableRow key={attendanceStaff.staffId} attendanceDates={attendanceDatesForPeriod} endDate={endDate} fromDate={fromDate} attendances={attendances} attendanceStaff={attendanceStaff} />
                    ))
                }
            </tbody>
        </table>
    </div>
}